import React from 'react'
import { connect } from 'react-redux'
import ui from 'redux-ui'
import { Button, Header, Icon} from 'semantic-ui-react'
import { Modal } from 'semantic-ui-react-with-store'

// All API errors surface through this one modal; `kind` (set via showMainModal) picks the
// icon, copy and what the button does:
//   action 'login'   -> navigate to the login page (session expired)
//   action 'home'    -> navigate back to the dashboard (unexpected errors)
//   action 'dismiss' -> just close, leave the user where they are
// `contact: true` adds a small "mail us" line, for errors that shouldn't normally happen.
const VARIANTS = {
  session:   { icon: 'sign in',      locale: 'session_modal',   action: 'login' },
  forbidden: { icon: 'ban',          locale: 'forbidden_modal', action: 'home', contact: true },
  notFound:  { icon: 'search',       locale: 'not_found_modal', action: 'home', contact: true },
  error:     { icon: 'warning sign', locale: 'error_modal',     action: 'stay', contact: true },
}

class MainModal extends React.Component {
  renderAction(variant, base) {
    if (variant.action === 'login') {
      return (
        <Button color='green' inverted href={Routes.session_path()}>
          <Icon name='unlock' />
          {I18n.t(`${base}.login`)}
        </Button>
      )
    }
    if (variant.action === 'home') {
      return (
        <Button color='green' inverted href={Routes.compass_path()}>
          <Icon name='home' />
          {I18n.t(`${base}.back_to_home`)}
        </Button>
      )
    }
    return (
      <Button color='green' inverted onClick={() => this.props.updateUI('isMainModalVisible', false)}>
        {I18n.t(`${base}.close`)}
        <Icon name='arrow right' />
      </Button>
    )
  }

  render() {
    const variant = VARIANTS[this.props.ui.kind] || VARIANTS.session
    const base = `components.main_modal.${variant.locale}`

    return (
      <Modal basic size='small' open={this.props.ui.isMainModalVisible}>
        <Header icon={variant.icon} content={I18n.t(`${base}.title`)} />
        <Modal.Content>
          <p>{I18n.t(`${base}.text`)}</p>
          {variant.contact &&
            <p style={{ fontSize: '0.85em', opacity: 0.75, marginTop: '1em' }}>
              {I18n.t('components.main_modal.contact.text')}{' '}
              <a href={`mailto:${I18n.t('components.main_modal.contact.email')}`} style={{color: 'orange'}}>
                {I18n.t('components.main_modal.contact.email')}
              </a>
            </p>
          }
        </Modal.Content>
        <Modal.Actions>
          {this.renderAction(variant, base)}
        </Modal.Actions>
      </Modal>
    )
  }
}

export default connect()(ui({ key: 'mainModal',  state: { isMainModalVisible: false, kind: 'session' } })(MainModal));
